import { defineMessages } from 'react-intl'

const scope = `procurify.components.DuplicateExpenseReportConfirmationModal`

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Confirmation',
  },
  description: {
    id: `${scope}.description`,
    defaultMessage:
      'This action will overwrite the previous expense report draft.',
  },
  confirmationButton: {
    id: `${scope}.confirmationButton`,
    defaultMessage: 'Confirm',
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: 'Cancel',
  },
})
